<template>
  <div>
    <base-info ref="baseInfo" v-model="form" v-loading="loading" :new-contract="newContract" />
    <div v-loading="loading" class="rj-page-card">
      <div class="rj-page-card__title">
        合同附件信息
      </div>
      <div class="rj-page-card__content">
        <contract-file v-if="form.id" :contract-num="form.id" />
      </div>
    </div>

    <product-list
      ref="product"
      v-loading="productLoading"
      :rebate-amount="form.rebateAmount"
      :communication-order-discount="form.communicationOrderDiscount"
      :sales-type="form.salesType"
      :rebate="form.rebate"
      :contract-type="form.contractType"
      :form="form"
      @chooseAddress="(val)=>{form.receiptAddressId=val.id}"
    />

    <div class="rj-page-card">
      <div class="rj-page-card__content">
        <el-button type="primary" :loading="loading" @click="submit(0)">
          发布合同
        </el-button>
        <!-- <el-button type="primary" :loading="loading" @click="submit(1)">保存草稿</el-button> -->
      </div>
    </div>
  </div>
</template>
<script type="es6">
import baseInfo from './baseInfo.vue';
// import productList from '../../orderPersion/handledrafts/productList.vue';
import productList from './productList/index.vue';
import contractFile from '../../Chief/contract/common/contractFile';
import { saveOrderExtraPriceContract, getContractDetailAllInfoByConNum, getContractProductInfoByContractId, getReceiptAddressByContractId } from '@/API';
export default {
  data () {
    return {
      newContract: 'newContract',
      form: {
        paymentMethodName: '立即'
      },
      loading: false,
      productLoading: false
    };
  },
  props: {
    contractNum: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    baseInfo,
    productList,
    contractFile
  },
  computed: {},
  methods: {
    initData () {
      this.loading = true;
      getContractDetailAllInfoByConNum(this.contractNum).then((res) => {
        this.loading = false;
        let json = res.data;
        if (json.status === '200') {
          this.form = json.data;
          this.form.paymentMethodName = '立即';
          this.$nextTick(() => {
            this.$refs.baseInfo.setInitData();
            this.initProduct();
          });
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    initProduct () {
      getContractProductInfoByContractId(this.form.id).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$refs.product.productList = json.data;
          this.form.authorizationEmail = json.data.data[0].authorizationEmail ? json.data.data[0].authorizationEmail : '';
        }
      }).catch(() => {
      });
      getReceiptAddressByContractId(this.form.id).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$refs.product.address = json.data;
        }
      }).catch(() => {
      });
      // axios.all([
      //   getContractProductInfoByContractId(this.form.id),
      //   getReceiptAddressByContractId(this.form.id)
      // ]).then((res) => {
      //   let fjson = res[0].data;
      //   let sjson = res[1].data;
      //   this.productLoading = false;
      //   this.form.authorizationEmail = res[0].data.data[0].authorizationEmail ? res[0].data.data[0].authorizationEmail : '';
      //   if (fjson.status === '200') {
      //     this.$refs.product.productList = fjson.data;
      //   }
      //   if (sjson.status === '200') {
      //     this.$refs.product.address = sjson.data;
      //     console.log(555555555555555);
      //   }
      // }).catch(() => {
      //   this.productLoading = false;
      //   console.log(78888888888888888888888);
      // });
    },
    async submit (val) {
      let baseR = true;
      let Product = {};
      if (!val) {
        baseR = await this.$refs.baseInfo.validate();
        baseR.contractInfo.isDraft = false;
      } else {
        baseR = this.$refs.baseInfo.validatedrafts();
        baseR.contractInfo.isDraft = true;
      }
      if (val) {
        Product = await this.$refs.product.validateDraft();
      } else {
        Product = await this.$refs.product.validate();
      }

      if (baseR && Product) {
        val ? baseR.contractInfo.isDraft = true : baseR.contractInfo.isDraft = false;
        baseR.contractDetail.actualSettlementAmount = Product.actualSettlementAmount;
        baseR.contractDetail.orderSales = Product.orderSales;
        this.loading = true;
        Product.productList.forEach((item) => {
          item.authorizationEmail = baseR.contractDetail.authorizationEmail;
        });
        saveOrderExtraPriceContract({ ...baseR, contractProductInfos: Product.productList }).then((res) => {
          let json = res.data;
          this.loading = false;
          if (json.status === '200') {
            this.$router.push({ name: 'assistantContractList' });
          }
        }).catch(() => {
          this.loading = false;
        });
      }
    }
  },
  mounted () {
    this.initData();
  }
};
</script>
